import { Injectable } from '@angular/core';
import {
    SearchStateService,
    SearchCriteria
} from '../shared/search-state.service';
import { UserCto } from 'src/app/api/models';

// User-specific search criteria interface
export interface UserSearchCriteria extends SearchCriteria {
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    userGuid?: string | null;
    userId?: number | null;
    apiUserId?: string | null;
    apiUserCompanyId?: string | null;
    companyId?: number | null;
}

// User search state service
@Injectable({
    providedIn: 'root'
})
export class UserSearchStateService extends SearchStateService<
    UserCto,
    UserSearchCriteria
> {
    constructor() {
        super({
            storageKey: 'user-search-state',
            entityName: 'user'
        });
    }
}
